import React from "react";

import { DrawerProps, Typography } from "@mui/material";
import { RiCloseLine } from "react-icons/ri";

import { ButtonClose, DrawerStyled, MainSection, HeaderDrawer, Content } from "./styled";

const Drawer = (props: DrawerProps) => {
  const { title, children, onClose, ...rest } = props;

  return (
    <DrawerStyled anchor="right" onClose={onClose} {...rest}>
      <MainSection>
        <HeaderDrawer>
          <Typography
            color="#308CDB"
            fontFamily="Manrope"
            fontWeight={700}
            fontSize="16px"
            lineHeight="24px"
          >
            {title}
          </Typography>
          <ButtonClose onClick={() => onClose && onClose({}, "escapeKeyDown")}>
            <RiCloseLine size={20} color="#308CDB" />
          </ButtonClose>
        </HeaderDrawer>
        <Content>{children}</Content>
      </MainSection>
    </DrawerStyled>
  );
};

export default Drawer;
